/* lua.js generated code 0.3.0 */

OpenFunscareLogic = xClass("OpenFunscareLogic")
FunscareTabIds = table(
    [1, "Shequ", 0],
    [1, "Gonglue", 1],
    [1, "Kefu", 2]
)
OpenFunscareLogic.openFunscare = function (defaultTab, onSuccess, onCancel, onFailed) {
    var self = this
    if (!ReachabilityUtil.getInstance().isNetworkAvailable()) {
        Toast.make("网络无连接", null, function () {
            if (type(onFailed) === "function") {
                onFailed()
            }
        })
        return 
    }
    defaultTab = defaultTab || 0
    if (__IOS) {
        self.openFunscareIOS(defaultTab, onSuccess, onCancel, onFailed)
    } else if (__ANDROID) {
        self.openFunscareAndroid(defaultTab, onSuccess, onCancel, onFailed)
    } else {
        self.openFunscareWIN32(defaultTab, onSuccess, onCancel, onFailed)
    }
}
OpenFunscareLogic.openForum = function (defaultTab, onSuccess, onCancel, onFailed) {
    var self = this
    self.openForumWIN32(defaultTab, onSuccess, onCancel, onFailed)
}
OpenFunscareLogic.openForumWIN32 = function (defaultTab, onSuccess, onCancel, onFailed) {
    GameProxy.getInstance().openForum(defaultTab, onSuccess, onFailed, onCancel)
}
OpenFunscareLogic.openFunscareWIN32 = function (defaultTab, onSuccess, onCancel, onFailed) {
    GameProxy.getInstance().openFC(defaultTab, onSuccess, onFailed, onCancel)
}
